import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import loginReducer from './modules/login/reducers';
import aboutReducer from './modules/about/reducers';
import signupReducer from './modules/signup/reducers';
import loaderReducer from './modules/loader';
import loaderMiddleware from './store/loaderMiddleware';

import forgotPasswordReducer from './modules/forgotPassword/reducers';
import {
  workerReducer,
  workerCounterReducer,
  workerCreateReducer,
  pendingWorkerListReducer,
  workerInvitationReducer,
  workerDetailReducer,
  deleteWorkerQualificationReducer,
  updateWorkerDocumentsRedcuer,
  updateWOrkerPreferenceReducer,
  updateWorkerQualificationReducer,
  updateWorkerSkillAndExperienceReducer,
  workerStatusUpdateReducer,
  mapWorkerQualificationReducer,
  workerDocumentStatusUpdateReducer, // <--- Add this import
  markWorkerAsViewReducer,
  updateWorkerViolationFlagReducer,
  rateWorkerReducer,
  updateWorkerRatingReducer,
  updateWorkerRatesReducer,
  fetchWorkerPreferredTimingsReducer,
  workerStatisticsReducer,
  workerShiftHistoryReducer,
  workerCustomFormSubmissionsReducer,
  workerRoleDocumentRequirementsBulkReducer,
  workerBulkUploadReducer,
  pastShiftWorkerListReducer,
} from './modules/worker';
import {
  facilityReducer,
  facilityStatisticsReducer,
  facilityLocationsReducer,
  facilityDetailsReducer,
  updateFacilityStatusReducer,
  updateFacilityDocumentDateReducer,
  updateFacilityViewStatusReducer,
  facilityShiftStaticsReducer,
  acceptRejectFacilityDocumentReducer,
  facilitySignupReducer,
  facilityTypesReducer,
  facilityTypeDocumentRequirementsReducer,
  facilityDocumentUploadReducer,
  updateFacilityViolationFlagReducer,
  facilityUsersReducer,
  updateFacilityProfileReducer,
  facilityShiftHistoryReducer,
  facilityReportStatsReducer,
  facilityWorkerAttendanceReducer,
  facilityDashboardStatisticsReducer,
  facilityShiftStatusChartReducer,
  facilityShiftCalendarReducer,
  facilityAssignedWorkersReducer
} from './modules/facility';
import { facilityProfileReducer } from './modules/facilityProfile';
import { qualificationReducer } from './modules/qualification';
import { locationReducer } from './modules/location';
import { skillReducer } from './modules/skill';
import { roleReducer } from './modules/role';
import { orgProfileReducer, updateOrgProfileReducer } from './modules/orgProfile';
import { facilityShiftListReducer, orgFacilityPendingShiftsReducer, allShiftsReducer, shiftStatisticsReducer, todayShiftStatisticsReducer, cancelShiftReducer, updateShiftAttendanceReducer, ongoingShiftsReducer, forceCancelShiftReducer, monitoringShiftsReducer, shiftRequestsReducer, facilityShiftRequestsReducer, updateShiftRequestStatusReducer, completeShiftRequestReducer, cancelShiftRequestReducer, cancellationWarningReducer, validateWorkerShiftTimingReducer, shiftBoardStatsReducer, organizationClockInReducer, organizationClockOutReducer } from './modules/shift';
import { scheduleInterviewSlice, getInterviewDetailSlice, updateInterviewSlice, cancelInterviewSlice } from './modules/interview/reducers';
import fcmReducer from './modules/fcm/reducers';
import {
  facilityShiftCreateReducer, workerSuggestionsReducer, facilityShiftUpdateReducer,
  facilityShiftDetailsReducer,
  assignWorkersReducer,
  shiftExtensionReducer,
  facilityShiftPastCreateReducer,
  facilityShiftPastUpdateReducer,
  deleteCancelledShiftReducer
} from './modules/facilityShifts/reducers';
import { userProfileReducer } from './modules/user/reducers'; // Corrected import path and reducer name
import { invoiceReducer } from './modules/invoice';
import { notificationsReducer } from './modules/notifications/reducers';
// Master Data Imports
import {
  createQualificationReducer,
  searchQualificationsReducer,
  updateQualificationReducer,
  deleteQualificationReducer,
  createRoleReducer,
  searchRolesReducer,
  updateRoleReducer,
  deleteRoleReducer,
  createFacilityTypeReducer,
  searchFacilityTypesReducer,
  updateFacilityTypeReducer,
  deleteFacilityTypeReducer,
  createDocumentTypeReducer,
  searchDocumentTypesReducer,
  updateDocumentTypeReducer,
  deleteDocumentTypeReducer,
  createDesignationReducer,
  searchDesignationsReducer,
  updateDesignationReducer,
  deleteDesignationReducer,
  createRoleDocumentMappingReducer,
  getRoleDocumentMappingReducer,
  createFacilityTypeDocumentMappingReducer,
  getFacilityTypeDocumentMappingReducer,
  searchCancellationReasonsReducer,
  createCancellationReasonReducer,
  updateCancellationReasonReducer,
  deleteCancellationReasonReducer,
  searchBanksReducer,
  uploadBankCSVReducer,
  createConfigReducer,
  searchConfigsReducer,
  updateConfigReducer,
  deleteConfigReducer,
  listConfigsReducer,
  customFormReducer,
  mapInputsToFormReducer,
  deleteCustomFormReducer,
  publishCustomFormReducer,
  deleteCustomFormFieldReducer,
  getBankFormFieldsReducer,
  bankFormListReducer,
  createBankFormFieldReducer,
  getCustomFormFieldsReducer,
  addCustomFormFieldReducer,
  updateCustomFormFieldReducer,
  updateBankFormFieldReducer,
  deleteBankFormFieldReducer,
  softDeleteBankFormFieldReducer,
} from './modules/masterdata';
import { reportsReducer } from './modules/reports';



import { fileReducer } from './modules/file';
import { superadminReducer } from './modules/superadmin';
import { accessControlReducer } from './modules/accessControl';
import subscriptionReducer from './modules/subscription/reducers';
import { orgDashboardReducer } from './modules/orgDashboard';

const appReducer = combineReducers({
  login: loginReducer,
  about: aboutReducer,
  signup: signupReducer,
  loader: loaderReducer,
  forgotPassword: forgotPasswordReducer,
  worker: workerReducer,
  workerCounts: workerCounterReducer,
  workerCreate: workerCreateReducer,
  facility: facilityReducer,
  facilityStatistics: facilityStatisticsReducer,
  facilityLocations: facilityLocationsReducer,
  facilityDetails: facilityDetailsReducer,
  qualification: qualificationReducer,
  location: locationReducer,
  pendingWorkers: pendingWorkerListReducer,
  resendInvitation: workerInvitationReducer,
  workerDetails: workerDetailReducer,
  skills: skillReducer,
  role: roleReducer,
  deleteWorkerQualification: deleteWorkerQualificationReducer,
  updateWorkerDocuments: updateWorkerDocumentsRedcuer,
  updateWorkerPreference: updateWOrkerPreferenceReducer,
  updateWorkerQualification: updateWorkerQualificationReducer,
  updateWorkerSkillAndExperience: updateWorkerSkillAndExperienceReducer,
  workerStatusUpdate: workerStatusUpdateReducer,
  mapWorkerQualification: mapWorkerQualificationReducer,
  workerDocumentStatusUpdate: workerDocumentStatusUpdateReducer,
  updateFacilityStatus: updateFacilityStatusReducer,
  orgProfile: orgProfileReducer,
  updateOrgProfile: updateOrgProfileReducer,
  updateFacilityDocumentDates: updateFacilityDocumentDateReducer,
  updateFacilityViewStatus: updateFacilityViewStatusReducer,
  facilityShiftStatics: facilityShiftStaticsReducer,
  facilityShiftList: facilityShiftListReducer,
  orgFacilityPendingShifts: orgFacilityPendingShiftsReducer,
  acceptRejectFacilityDocument: acceptRejectFacilityDocumentReducer,
  scheduleInterviewMessage: scheduleInterviewSlice.reducer,
  interviewDetails: getInterviewDetailSlice.reducer,
  updateInterview: updateInterviewSlice.reducer,
  cancelInterview: cancelInterviewSlice.reducer,
  facilitySignup: facilitySignupReducer,
  facilityTypes: facilityTypesReducer,
  userProfile: userProfileReducer,
  facilityTypeDocumentRequirements: facilityTypeDocumentRequirementsReducer,
  facilityDocumentUpload: facilityDocumentUploadReducer,
  markWorkerAsView: markWorkerAsViewReducer,
  fcm: fcmReducer,
  allShifts: allShiftsReducer,
  shiftStatistics: shiftStatisticsReducer,
  todayShiftStatistics: todayShiftStatisticsReducer,
  updateFacilityViolationFlag: updateFacilityViolationFlagReducer,
  updateWorkerViolationFlag: updateWorkerViolationFlagReducer,
  facilityUsers: facilityUsersReducer,
  facilityShiftCreate: facilityShiftCreateReducer,
  workerSuggestions: workerSuggestionsReducer,
  facilityShiftUpdate: facilityShiftUpdateReducer,
  facilityShiftDetails: facilityShiftDetailsReducer,
  facilityShiftPastCreate: facilityShiftPastCreateReducer,
  facilityShiftPastUpdate: facilityShiftPastUpdateReducer,
  assignWorkers: assignWorkersReducer,
  shiftExtension: shiftExtensionReducer,
  deleteCancelledShift: deleteCancelledShiftReducer,
  cancelShift: cancelShiftReducer,
  updateShiftAttendance: updateShiftAttendanceReducer,
  rateWorker: rateWorkerReducer,
  ongoingShifts: ongoingShiftsReducer,
  updateWorkerRating: updateWorkerRatingReducer,
  updateFacilityProfile: updateFacilityProfileReducer,
  facilityProfile: facilityProfileReducer,
  facilityDocumentUpload2: facilityDocumentUploadReducer,
  invoice: invoiceReducer,
  facilityShiftHistory: facilityShiftHistoryReducer,
  facilityReportStats: facilityReportStatsReducer,
  facilityWorkerAttendance: facilityWorkerAttendanceReducer,
  facilityDashboardStatistics: facilityDashboardStatisticsReducer,
  facilityShiftStatusChart: facilityShiftStatusChartReducer,
  notifications: notificationsReducer,
  createQualification: createQualificationReducer,
  searchQualifications: searchQualificationsReducer,
  updateQualification: updateQualificationReducer,
  deleteQualification: deleteQualificationReducer,
  createRole: createRoleReducer,
  searchRoles: searchRolesReducer,
  updateRole: updateRoleReducer,
  deleteRole: deleteRoleReducer,
  createFacilityType: createFacilityTypeReducer,
  searchFacilityTypes: searchFacilityTypesReducer,
  updateFacilityType: updateFacilityTypeReducer,
  deleteFacilityType: deleteFacilityTypeReducer,
  createDocumentType: createDocumentTypeReducer,
  searchDocumentTypes: searchDocumentTypesReducer,
  updateDocumentType: updateDocumentTypeReducer,
  deleteDocumentType: deleteDocumentTypeReducer,
  createDesignation: createDesignationReducer,
  searchDesignation: searchDesignationsReducer,
  updateDesignation: updateDesignationReducer,
  deleteDesignation: deleteDesignationReducer,
  createRoleDocumentMapping: createRoleDocumentMappingReducer,
  getRoleDocumentMapping: getRoleDocumentMappingReducer,
  createFacilityTypeDocumentMapping: createFacilityTypeDocumentMappingReducer,
  getFacilityTypeDocumentMapping: getFacilityTypeDocumentMappingReducer,
  searchCancellationReasons: searchCancellationReasonsReducer,
  createCancellationReason: createCancellationReasonReducer,
  updateCancellationReason: updateCancellationReasonReducer,
  deleteCancellationReason: deleteCancellationReasonReducer,
  searchBanks: searchBanksReducer,
  uploadBankCSV: uploadBankCSVReducer,
  createConfig: createConfigReducer,
  searchConfigs: searchConfigsReducer,
  updateConfig: updateConfigReducer,
  deleteConfig: deleteConfigReducer,
  listConfigs: listConfigsReducer,
  superadmin: superadminReducer,
  accessControl: accessControlReducer,
  subscription: subscriptionReducer,


  forceCancelShift: forceCancelShiftReducer,
  facilityShiftCalendar: facilityShiftCalendarReducer,
  facilityAssignedWorkers: facilityAssignedWorkersReducer,
  monitoringShifts: monitoringShiftsReducer,
  shiftRequests: shiftRequestsReducer,
  facilityShiftRequests: facilityShiftRequestsReducer,
  updateShiftRequestStatus: updateShiftRequestStatusReducer,
  completeShiftRequest: completeShiftRequestReducer,
  cancelShiftRequest: cancelShiftRequestReducer,
  cancellationWarning: cancellationWarningReducer,
  validateWorkerShiftTiming: validateWorkerShiftTimingReducer,
  shiftBoardStats: shiftBoardStatsReducer,
  organizationClockIn: organizationClockInReducer,
  organizationClockOut: organizationClockOutReducer,
  file: fileReducer,
  updateWorkerRates: updateWorkerRatesReducer,
  workerPreferredTimings: fetchWorkerPreferredTimingsReducer,
  workerStatistics: workerStatisticsReducer,
  workerShiftHistory: workerShiftHistoryReducer,
  workerCustomFormSubmissions: workerCustomFormSubmissionsReducer,
  workerRoleDocumentRequirementsBulk: workerRoleDocumentRequirementsBulkReducer,
  workerBulkUpload: workerBulkUploadReducer,
  pastShiftWorkerList: pastShiftWorkerListReducer,
  reports: reportsReducer,
  customForm: customFormReducer,
  mapInputsToForm: mapInputsToFormReducer,
  deleteCustomForm: deleteCustomFormReducer,
  publishCustomForm: publishCustomFormReducer,
  deleteCustomFormField: deleteCustomFormFieldReducer,
  getBankFormFields: getBankFormFieldsReducer,
  bankFormList: bankFormListReducer,
  createBankFormField: createBankFormFieldReducer,
  getCustomFormFields: getCustomFormFieldsReducer,
  addCustomFormField: addCustomFormFieldReducer,
  updateCustomFormField: updateCustomFormFieldReducer,
  updateBankFormField: updateBankFormFieldReducer,
  deleteBankFormField: deleteBankFormFieldReducer,
  softDeleteBankFormField: softDeleteBankFormFieldReducer,
  orgDashboard: orgDashboardReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'login/logout') {
    // for all keys defined in your persistConfig(s)
    storage.removeItem('persist:root')
    // storage.removeItem('persist:otherKey')

    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['login'], // only login will be persisted
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // to avoid errors with redux-persist
    }).concat(loaderMiddleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type LoginAppDispatch = AppDispatch; // Define LoginAppDispatch from AppDispatch
